import { render, staticRenderFns } from "./TalkMsgCall.vue?vue&type=template&id=58588ebe&scoped=true"
import script from "./TalkMsgCall.vue?vue&type=script&lang=js"
export * from "./TalkMsgCall.vue?vue&type=script&lang=js"
import style0 from "./TalkMsgCall.vue?vue&type=style&index=0&id=58588ebe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58588ebe",
  null
  
)

export default component.exports